import React, { createContext, useContext, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    TextField
} from '@mui/material';

const AlertContext = createContext();

// Tema renkleri
const themeColors = {
  primary: {
    main: '#fff',
    light: '#fff',
    dark: '#fff',
    contrastText: '#fff'
  },
  error: {
    main: '#fff',
    light: '#fff',
    dark: '#fff',
    contrastText: '#fff'
  },
  grey: {
    100: '#F2F6FA',
    200: '#EAEFF4',
    300: '#DFE5EF',
    400: '#7C8FAC',
    500: '#5A6A85'
  },
  background: {
    paper: '#fff'
  },
  action: {
    hover: 'rgba(255, 125, 0, 0.04)',
    selected: 'rgba(255, 125, 0, 0.08)',
    disabled: 'rgba(0, 0, 0, 0.26)',
    disabledBackground: 'rgba(0, 0, 0, 0.12)'
  }
};

export const useAlert = () => useContext(AlertContext);

export const AlertProvider = ({ children }) => {
    const [alert, setAlert] = useState(null);

    const [promptValue, setPromptValue] = useState('');

    const showAlert = ({ 
        type = 'info', 
        title, 
        message, 
        confirmButtonText, 
        cancelButtonText,
        onConfirm,
        onCancel,
        customStyle = {}, // Yeni eklenen özellik
        inputType,
        inputPlaceholder,
        inputValue = ''
    }) => {
        setPromptValue(inputValue);
        setAlert({
            type,
            title,
            message,
            confirmButtonText,
            cancelButtonText,
            onConfirm,
            onCancel,
            customStyle,
            inputType,
            inputPlaceholder
        });
    };

    const hideAlert = () => {
        setAlert(null);
        setPromptValue('');
    };

    const handleClose = () => {
        hideAlert();
    };

    const handleCancel = () => {
        alert.onCancel?.();
        hideAlert();
        setPromptValue('');
    };

    const handleConfirm = () => {
        if (alert.type === 'prompt') {
            alert.onConfirm?.(promptValue);
            // Prompt için dialog'u kapatma, callback'in kendi yönetmesine izin ver
        } else {
            alert.onConfirm?.();
            hideAlert();
        }
        setPromptValue('');
    };

    return (
        <AlertContext.Provider value={{ showAlert, hideAlert }}>
            {children}
            {alert && (
                <Dialog
                    open={Boolean(alert)}
                    onClose={handleClose}
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogTitle>
                        {alert.title}
                    </DialogTitle>
                    <DialogContent>
                        <Typography 
                            style={{ 
                                ...alert.customStyle,
                                marginTop: '8px',
                                color: '#FF6B00',
                                fontSize: '18px',
                                fontWeight: 'bold'
                            }}
                        >
                            {alert.message}
                        </Typography>
                        
                        {alert.type === 'prompt' && (
                            <TextField
                                fullWidth
                                multiline
                                rows={4}
                                label="Açıklama"
                                value={promptValue}
                                onChange={(e) => setPromptValue(e.target.value)}
                                placeholder={alert.inputPlaceholder || "Açıklama giriniz..."}
                                variant="outlined"
                                sx={{ mt: 2 }}
                            />
                        )}
                    </DialogContent>
                    <DialogActions>
                        {(alert.type === 'confirm' || alert.type === 'prompt') && (
                            <Button onClick={handleCancel}>
                                {alert.cancelButtonText || 'İptal'}
                            </Button>
                        )}
                        <Button 
                            onClick={handleConfirm}
                            color={alert.type === 'error' ? 'error' : 'primary'}
                            variant="contained"
                            autoFocus
                            disabled={alert.type === 'prompt' && !promptValue.trim()}
                        >
                            {alert.confirmButtonText || 'Tamam'}
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </AlertContext.Provider>
    );
}; 